import {createSlice} from '@reduxjs/toolkit'

export const opportunityBankSlice = createSlice({
  name: 'opportunityBank',
  initialState: {
    opportunityList: [],
    totalCount: 0,
    lastUpdated: null,
    filters: {},
    refData: null,
    isRefDataLoading: false,
    refreshList: false
  },
  reducers: {
    setOpportunityList: (state, action) => {
      state.opportunityList = action.payload
    },
    setFilters: (state, action) => {
      state.filters = action.payload
    },
    setTotalCount: (state, action) => {
      state.totalCount = action.payload
    },
    setLastUpdated: (state, action) => {
      state.lastUpdated = action.payload
    },
    setRefData: (state, action) => {
      state.refData = action.payload
    },
    setRefDataLoading: (state, action) => {
      state.isRefDataLoading = action.payload
    },
    setRefreshList: (state, action) => {
      state.refreshList = action.payload
    }
  }
})

export const {
  setOpportunityList,
  setFilters,
  setTotalCount,
  setLastUpdated,
  setRefData,
  setRefDataLoading,
  setRefreshList
} = opportunityBankSlice.actions

export default opportunityBankSlice.reducer
